export default class ArticleSectionRoute {
  constructor(params) {
    this.name = 'ArticleSection';
    this.params = params;
  }
}
